import { gql } from '@apollo/client'

export const Mutation = gql`
  mutation DeleteAccommodationRoomType($companyId: ID!, $id: ID!) {
    deleteAccommodationRoomType(companyId: $companyId, id: $id) {
      accommodationRoomType {
        id
      }
      errors {
        path
        message
      }
    }
  }
`
